// Hash router. A screen is a function that renders into root and returns a cleanup.

export type Screen = (root: HTMLElement, params: string[]) => (() => void) | void;

const screens = new Map<string, Screen>();
let cleanup: (() => void) | void;
let rootEl: HTMLElement;

export function registerScreen(name: string, s: Screen) { screens.set(name, s); }

export function go(path: string) {
  if (location.hash === '#' + path) render(); else location.hash = path;
}

export function current(): { name: string; params: string[] } {
  const parts = location.hash.replace(/^#\/?/, '').split('/').filter(Boolean);
  return { name: parts[0] || 'hub', params: parts.slice(1).map(decodeURIComponent) };
}

function render() {
  if (cleanup) { try { cleanup(); } catch { /* ignore */ } cleanup = undefined; }
  const { name, params } = current();
  const s = screens.get(name) || screens.get('hub')!;
  rootEl.innerHTML = '';
  rootEl.dataset.screen = name;
  window.scrollTo(0, 0);
  cleanup = s(rootEl, params);
}

export function startRouter(root: HTMLElement) {
  rootEl = root;
  window.addEventListener('hashchange', render);
  render();
}
